export const PHONE_TRANSLATIONS = {
    "cs": {
        "label": "Telefonni cislo behem dne",
        "phoneRequiredMessage": "Povinný údaj",
        "invalidMessage": "Neplatné telefonní číslo. Telefonní číslo musí mít 10 číslic."
    },
    "da": {
        "label": "Tlf. i dagtimerne",
        "phoneRequiredMessage": "Dette felt skal udfyldes.",
        "invalidMessage": "Dette felt må kun indeholde romertal (IV, V, X)."
    },
    "de": {
        "label": "Telefon beruflich",
        "phoneRequiredMessage": "Dieses Feld muss ausgefüllt werden.",
        "invalidMessage": "Dieses Feld akzeptiert nur die Zeichen A-Z, 0-9."
    },
    "de_DE": {
        "invalidMessage": "Dieses Feld darf nur römische Zeichen enthalten (IV, V, X)."
    },
    'en': {
        'phoneRequiredMessage': 'Your phone number is required',
        'invalidMessage': 'Your phone number is invalid',
        'label': 'Phone Number',
        'placeholder': 'Phone Number'
    },
    'es': {
        'phoneRequiredMessage': 'Se requiere su número de teléfono',
        'invalidMessage': 'Su número de teléfono no es válido',
        'label': 'Número de teléfono',
        'placeholder': 'Número de teléfono'
    },
    "es_CL": {
        "label": "Número de Teléfono en el Día"
    },
    "es_ES": {
        "phoneRequiredMessage": "Es un campo obligatorio",
        "invalidMessage": "Este campo únicamente debe contener números romanos (IV, V, X)."
    },
    "fi": {
        "label": "Puhelinnumero paivisin",
        "phoneRequiredMessage": "Tämä kenttä on pakollinen.",
        "invalidMessage": "Tämä kenttä voi sisältää ainoastaan merkkejä A-Z ja 0-9."
    },
    "fr": {
        "label": "Numero de tel. professionnel",
        "phoneRequiredMessage": "Ceci est un champ obligatoire.",
        "invalidMessage": "Format invalide"
    },
    "fr_CA": {
        "label": "Numéro de téléphone (adresse d'expédition)"
    },
    "hu": {
        "label": "Napkozben hivhato telefonszam",
        "phoneRequiredMessage": "E mező kitöltése kötelező.",
        "invalidMessage": "Ez a mező csak római számokat (IV, V, X) tartalmazhat."
    },
    "in": {
        "label": "Home Phone",
        "phoneRequiredMessage": "This field is required.",
        "invalidMessage": "Hanya dapat diisi dengan angka 0-9"
    },
    "is": {
        "label": "Simanumer a daginn",
        "phoneRequiredMessage": "Þessa eyðu má ekki skilja eftir auða.",
        "invalidMessage": "Þessi eyða getur aðeins innihaldið rómverska bókstafi (IV, V, X)."
    },
    "it": {
        "label": "Telefono durante il giorno",
        "phoneRequiredMessage": "Questo è un campo obbligatorio.",
        "invalidMessage": "Questo campo può contenere solo caratteri romani (IV, V, X)."
    },
    "it_CH": {
        "invalidMessage": "Questo campo può contenere solo caratteri A-Z, 0-9."
    },
    "iw": {
        "label": "מספר טלפון לשעות היום",
        "phoneRequiredMessage": "This field is required."
    },
    "ja": {
        "label": "日中の電話番号：（例：0353213600）",
        "phoneRequiredMessage": "この項目は必須です。",
        "invalidMessage": "電話番号は、ハイフンを除いた数字のみ10桁または11桁で入力してください。"
    },
    "ms": {
        "label": "Home Phone",
        "phoneRequiredMessage": "This field is required.",
        "invalidMessage": "Ruang ini hanya boleh diisi dengan karakter 0-9"
    },
    "nl": {
        "label": "Telefoonnummer overdag",
        "phoneRequiredMessage": "Dit veld is verplicht.",
        "invalidMessage": "Dit veld mag alleen de tekens A-Z, 0-9 bevatten."
    },
    "nl_NL": {
        "phoneRequiredMessage": "Dit is een verplicht veld.",
        "invalidMessage": "In dit veld mogen alleen Romeinse cijfers staan (IV, V, X)."
    },
    "no": {
        "label": "Tlf.nummer dag",
        "phoneRequiredMessage": "Dette er et obligatorisk felt.",
        "invalidMessage": "Dette feltet skal kun inneholde romerske tegn (IV, V, X)"
    },
    "pl": {
        "label": "Numer kontaktowy",
        "phoneRequiredMessage": "To pole należy obowiązkowo wypełnić.",
        "invalidMessage": "To pole może zawierać wyłącznie znaki arabskie (1, 2, 3)."
    },
    "pt": {
        "label": "Contacto telefónico durante o dia",
        "phoneRequiredMessage": "Campo é obrigatório",
        "invalidMessage": "Este campo poderá conter somente caracteres A-Z, 0-9."
    },
    "ro": {
        "label": "Telefon de zi",
        "phoneRequiredMessage": "Acest câmp este obligatoriu.",
        "invalidMessage": "Acest câmp poate conţine doar caractere A-Z, 0-9."
    },
    "ru": {
        "label": "Номер телефона в дневное время",
        "phoneRequiredMessage": "Это поле обязательно для заполнения.",
        "invalidMessage": "Это поле может содержать только буквы A-Z или цифры 0-9."
    },
    "ru_UA": {
        "label": "Номер телефона в дневное время: (необязательно)"
    },
    "sk": {
        "label": "Telefonne cislo pocas dna",
        "phoneRequiredMessage": "Je potrebné vyplniť toto pole.",
        "invalidMessage": "Toto pole môže obsahovať iba znaky A-Z, 0-9."
    },
    "sv": {
        "label": "Telefonnummer dagtid",
        "phoneRequiredMessage": "Detta fält måste ifyllas.",
        "invalidMessage": "Detta fält kan bara innehålla romerska tecken (IV, V, X)."
    },
    "th": {
        "label": "โทรศัพท์ที่สามารถติดต่อได้",
        "phoneRequiredMessage": "กรุณากรอกข้อมูลนี้ให้ครบถ้วน",
        "invalidMessage": "ส่วนนี้ให้เลือกเป็นตัวเลข 0-9 เท่านั้น"
    },
    "th_SE": {
        "phoneRequiredMessage": "จำเป็นต้องกรอกช่องนี้"
    },
    "th_TH": {
        "label": "เบอร์โทรศัพท์บ้าน"
    },
    "tr": {
        "label": "Mesai Saatleri icin Telefon Numarasi",
        "phoneRequiredMessage": "Bu alanı doldurmak zorunludur.",
        "invalidMessage": "Geçersiz telefon numarası. Telefon numarası rakamlar şeklinde 10 dijitten oluşmalıdır."
    },
    "uk": {
        "label": "Номер телефону в денний час: (необов'язково)",
        "phoneRequiredMessage": "Це поле є обов язковим для заповнення.",
        "invalidMessage": "Це поле може містити тільки літери AZ або цифри 0-9."
    },
    "vi": {
        "label": "Số điện thoại liên lạc: (xxx-xxx-xxxx)",
        "phoneRequiredMessage": "Trường thông tin bắt buộc",
        "invalidMessage": "Trường thông tin này chỉ chứa các chữ không dấu"
    },
    'zh': {
        'phoneRequiredMessage': '您的电话号码是必需的',
        'invalidMessage': '你的电话号码无效',
        'label': '电话号码（xxx-xxx-xxxx）',
        'placeholder': '电话号码'
    }
};
